import { render } from "./PaymentCompleted.vue?vue&type=template&id=042d7e85&scoped=true&ts=true"
import script from "./PaymentCompleted.vue?vue&type=script&lang=ts"
export * from "./PaymentCompleted.vue?vue&type=script&lang=ts"

import "./PaymentCompleted.vue?vue&type=style&index=0&id=042d7e85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042d7e85"]])

export default __exports__